import { LogIn } from "lucide-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useCartSheet } from "@/features/cart";
import { useSearchDialog } from "@/features/search";
import { useIsMobile } from "@/shared/lib/use-mobile";
import { ROUTES } from "@/shared/model/routes";
import { Button } from "@/shared/ui/kit/button";

import { useNavigationModel } from "./model";
import {
  NavLogo,
  NavCatalogButton,
  NavSearch,
  NavActions,
  NavMenu,
  NavDrawer,
} from "./ui";

export function Header() {
  const { t } = useTranslation();
  const model = useNavigationModel();
  const isMobile = useIsMobile();

  const cartSheet = useCartSheet();
  const searchDialog = useSearchDialog();
  const [isMac, setIsMac] = useState(true);

  useEffect(() => {
    setIsMac(navigator.platform.toUpperCase().indexOf("MAC") >= 0);
  }, []);

  return (
    <>
      <header className="sticky top-0 z-50 h-14 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-full items-center gap-2 md:gap-4">
          {/* Logo - always visible */}
          <NavLogo />

          {/* Catalog - tablet/desktop */}
          <div className="hidden md:flex flex-1">
            <NavCatalogButton />
          </div>

          {/* Nav menu - desktop only (покупателям/продавцам) */}
          <div className="hidden lg:flex">
            <NavMenu />
          </div>

          {/* Search - tablet/desktop */}
          <div className="hidden md:flex ">
            <NavSearch onOpen={searchDialog.open} isMac={isMac} />
          </div>

          {/* Actions (cart, notifications, support, account) - tablet/desktop */}
          <div className="hidden md:flex items-center gap-1">
            <NavActions model={model} onCartOpen={cartSheet.open} />
          </div>

          {!model.isAuthenticated && isMobile && (
            <div className="lg:hidden w-full flex">
              <NavCatalogButton />

              <Button
                variant="ghost"
                size="sm"
                asChild
                className="ml-auto lg:ml-0"
              >
                <Link to={ROUTES.LOGIN}>
                  <LogIn className="w-4 h-4 mr-1" />
                  <span className="hidden sm:inline">{t("nav.login")}</span>
                </Link>
              </Button>
            </div>
          )}

          {/* Mobile nav toggle - tablet/mobile */}
          <div className="lg:hidden ml-auto">
            <NavDrawer model={model} onSearchOpen={searchDialog.open} />
          </div>
        </div>
      </header>
    </>
  );
}
